/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} User_Detail_Finals_CountInputs */



/**
* | output |
* | --- |
* | "Finals: {count}" |
*
* @param {User_Detail_Finals_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_finals_count = /** @type {((inputs: User_Detail_Finals_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Finals_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Finales : ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Finales: ${i?.count}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Finais: ${i?.count}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Finali: ${i?.count}`)
	return /** @type {LocalizedString} */ (`Finals: ${i?.count}`)
});